var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "soli-round mx-auto mb-3",
      staticStyle: { "max-width": "600px" },
    },
    [
      _c(
        "v-container",
        { class: { "pa-5": _vm.$vuetify.breakpoint.smAndUp } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              staticStyle: { overflow: "hidden !important" },
              attrs: { id: "get-started-submit" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-list",
                { staticStyle: { overflow: "hidden !important" } },
                [
                  false
                    ? _c(
                        "v-list-item",
                        {
                          staticClass: "soli-grey font-weight-bold text-start",
                          attrs: { dense: "" },
                        },
                        [_vm._v("Who will be learning?")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c(
                        "v-list-item",
                        [
                          _c(
                            "v-radio-group",
                            {
                              staticClass: "mt-0",
                              attrs: { mandatory: "" },
                              model: {
                                value: _vm.form.has_child,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "has_child", $$v)
                                },
                                expression: "form.has_child",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: { label: "Me", value: false },
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: { label: "My Child", value: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.includeOnline
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass:
                                "soli-grey font-weight-bold text-start",
                              attrs: { dense: "" },
                            },
                            [
                              _vm._v(
                                "\n                        Do you want lessons online or in-person?\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-0",
                                  attrs: { mandatory: "" },
                                  model: {
                                    value: _vm.form.online,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "online", $$v)
                                    },
                                    expression: "form.online",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "In-person", value: false },
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "Online", value: true },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.has_child
                    ? _c(
                        "v-list-item",
                        {
                          staticClass:
                            "soli-grey font-weight-bold text-start px-5",
                          attrs: { dense: "" },
                        },
                        [_vm._v("Your Information")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { staticClass: "mb-3" },
                    [
                      _vm.requireLastNames
                        ? _c(
                            "div",
                            { staticClass: "w-full" },
                            [
                              _c(
                                "v-row",
                                { staticClass: "my-0" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-1",
                                      attrs: { cols: "12", sm: "6" },
                                    },
                                    [
                                      _c("SoliText", {
                                        class: {
                                          "mb-3": _vm.$vuetify.breakpoint.xs,
                                        },
                                        attrs: {
                                          icon: "person",
                                          label: "Your First Name",
                                          rules: [
                                            (v) =>
                                              !!v ||
                                              "Your first name is required",
                                          ],
                                          hideDetails: "auto",
                                          error: _vm.errors.first_name,
                                        },
                                        model: {
                                          value: _vm.form.first_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "first_name",
                                              $$v
                                            )
                                          },
                                          expression: "form.first_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-1",
                                      attrs: { cols: "12", sm: "6", lg: "6" },
                                    },
                                    [
                                      _c("SoliText", {
                                        attrs: {
                                          icon: "person",
                                          label: "Your Last Name",
                                          rules: [
                                            (v) =>
                                              !!v ||
                                              "Your last name is required",
                                          ],
                                          hideDetails: "auto",
                                          error: _vm.errors.last_name,
                                        },
                                        model: {
                                          value: _vm.form.last_name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "last_name", $$v)
                                          },
                                          expression: "form.last_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c("SoliText", {
                            class: { "mb-3": _vm.$vuetify.breakpoint.xs },
                            attrs: {
                              icon: "person",
                              label: "Your First Name",
                              rules: [
                                (v) => !!v || "Your first name is required",
                              ],
                              hideDetails: "auto",
                              error: _vm.errors.first_name,
                            },
                            model: {
                              value: _vm.form.first_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "first_name", $$v)
                              },
                              expression: "form.first_name",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { staticClass: "mb-3" },
                    [
                      _c("BookingEmail", {
                        attrs: { hideDetails: "auto", error: _vm.form.email },
                        model: {
                          value: _vm.form.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { staticClass: "mb-3" },
                    [
                      _c("SoliPhone", {
                        attrs: { hideDetails: "auto", error: _vm.form.phone },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  false
                    ? _c(
                        "v-list-item",
                        { staticClass: "mb-3" },
                        [
                          _c("v-select", {
                            attrs: {
                              dense: "",
                              "hide-details": "auto",
                              label: "How did you find us?",
                              solo: "",
                              outlined: "",
                              "prepend-inner-icon": "celebration",
                              flat: "",
                              clearable: "",
                              items: [
                                "From a Student or Parent",
                                "From a Teacher",
                                "Event",
                                "Web Search",
                                "Social Media",
                                "Other",
                              ],
                            },
                            model: {
                              value: _vm.form.referrer,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "referrer", $$v)
                              },
                              expression: "form.referrer",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.has_child
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass:
                                "soli-grey font-weight-bold text-start px-5",
                            },
                            [
                              _vm._v(
                                "\n                        Child Information:\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            { staticClass: "mb-3" },
                            [
                              _vm.requireLastNames
                                ? _c(
                                    "div",
                                    { staticClass: "w-full" },
                                    [
                                      _c(
                                        "v-row",
                                        { staticClass: "my-0" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c("SoliText", {
                                                key: _vm.form.has_child,
                                                class: {
                                                  "mb-3":
                                                    _vm.$vuetify.breakpoint.xs,
                                                },
                                                attrs: {
                                                  icon: "person",
                                                  label: "Child's First Name",
                                                  rules: _vm.form.has_child
                                                    ? [
                                                        (v) =>
                                                          !!v ||
                                                          `Your child's first name is required`,
                                                      ]
                                                    : [],
                                                  hideDetails: "auto",
                                                  error:
                                                    _vm.errors.child_first_name,
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.child_first_name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "child_first_name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.child_first_name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c("SoliText", {
                                                key: _vm.form.has_child,
                                                attrs: {
                                                  icon: "person",
                                                  label: "Child's Last Name",
                                                  rules: _vm.form.has_child
                                                    ? [
                                                        (v) =>
                                                          !!v ||
                                                          `Your child's last name is required`,
                                                      ]
                                                    : [],
                                                  hideDetails: "auto",
                                                  error:
                                                    _vm.errors.child_last_name,
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.child_last_name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "child_last_name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.child_last_name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c("SoliText", {
                                    key: _vm.form.has_child,
                                    class: {
                                      "mb-3": _vm.$vuetify.breakpoint.xs,
                                    },
                                    attrs: {
                                      icon: "person",
                                      label: "Child's First Name",
                                      rules: _vm.form.has_child
                                        ? [
                                            (v) =>
                                              !!v ||
                                              `Your child's first name is required`,
                                          ]
                                        : [],
                                      hideDetails: "auto",
                                      error: _vm.errors.child_first_name,
                                    },
                                    model: {
                                      value: _vm.form.child_first_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "child_first_name",
                                          $$v
                                        )
                                      },
                                      expression: "form.child_first_name",
                                    },
                                  }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("SoliBirthday", {
                                key: _vm.form.has_child,
                                attrs: {
                                  label: "Child's Birthday",
                                  required: _vm.form.has_child,
                                },
                                model: {
                                  value: _vm.form.child_birthday,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "child_birthday", $$v)
                                  },
                                  expression: "form.child_birthday",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c(
                        "div",
                        { staticClass: "px-6 flex flex-col align-start pb-4" },
                        [
                          _c("v-checkbox", {
                            staticClass: "py-0",
                            attrs: {
                              label:
                                "I agree to receive text messages from Musicologie",
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.form.sms_opted_in,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sms_opted_in", $$v)
                              },
                              expression: "form.sms_opted_in",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "caption soli-grey ml-8" }, [
                            _vm._v(
                              "\n                        Message & data rates may apply. Reply STOP to opt\n                        out.\n                        "
                            ),
                            _c("a", { attrs: { href: _vm.route("privacy") } }, [
                              _vm._v("Privacy Policy"),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c(
                        "v-card-text",
                        { staticClass: "caption soli-grey px-6" },
                        [
                          _vm._v(
                            "\n                    By submitting this form, you agree to receive SMS\n                    messages from Musicologie and to our\n                    "
                          ),
                          _c("a", { attrs: { href: _vm.route("privacy") } }, [
                            _vm._v("Privacy Policy"),
                          ]),
                          _vm._v(
                            ". Message\n                    & data rates may apply. Reply STOP to opt out.\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              Object.keys(_vm.errors).length
                ? _c(
                    "p",
                    {
                      staticClass:
                        "caption red--text mx-5 mb-6 flex justify-center",
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(Object.values(_vm.errors)[0]) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideSubmit
                ? _c(
                    "v-container",
                    { staticClass: "pt-0" },
                    [
                      _c("SoliBtn", {
                        attrs: {
                          type: "submit",
                          text: "Let's Go!",
                          loading: _vm.loading,
                          gradient: "gradient-orange",
                          block: "",
                          color: "soli-status-grey",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              true
                ? _c(
                    "v-card-text",
                    { staticClass: "caption soli-grey pb-0 pt-2 px-6" },
                    [
                      _vm._v(
                        "\n                By submitting this form, you agree to receive SMS messages\n                from Musicologie and to our\n                "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://musicologie.com/terms-and-conditions",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Privacy Policy")]
                      ),
                      _vm._v(
                        ". Message & data rates may apply. Reply STOP to opt out.\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }